import React, { useEffect } from 'react'
import ReactMarkdown from 'react-markdown'
import Image from 'next/image'
import {
  CheckOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Row, Col, Typography, Avatar, Card } from 'antd'
import DetailsWithPhoto from 'components/shared/DetailsWithPhoto'
import OptinInline from 'components/shared/OptinInline'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'

const { Title } = Typography

const TitleWithAuthor = ({ title, user }) => (
  // @ts-ignore-next-line
  <div style={{ margin: '0.5em 0', textWrap: 'pretty' }}>
    <Row style={{ display: 'flex' }}>
      <Col span={20} style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ marginRight: '1em' }}>
          {user.data?.attributes?.avatar && (
            <Avatar src={user.data.attributes.avatar} size={55} />
          )}
          {!user.data?.attributes?.avatar && (
            <Avatar size={32} icon={<UserOutlined />} />
          )}
        </div>
        <div>
          <Title level={2} style={{ marginBottom: 0 }}>
            {title}
          </Title>
          <Typography.Text disabled>
            {user.data?.attributes?.username}
          </Typography.Text>
        </div>
      </Col>
    </Row>
  </div>
)

const CreatedAction = ({ user }) => {
  return (
    <div style={{ marginLeft: '1em' }}>
      <Row>
        <Typography.Text>Asked By</Typography.Text>
      </Row>
      <Row>
        <Col style={{ marginRight: '0.5em' }}>
          {user.data?.attributes?.avatar && (
            <Avatar src={user.data.attributes.avatar} />
          )}
          {!user.data?.attributes?.avatar && (
            <Avatar size={32} icon={<UserOutlined />} />
          )}
        </Col>
        <Col>
          <Typography.Text>{user.data?.attributes?.username}</Typography.Text>
        </Col>
      </Row>
    </div>
  )
}

const UpdatedAction = ({ updatedAt }) => {
  return (
    <div style={{ marginLeft: '1em' }}>
      <Row>
        <Typography.Text>Updated On:</Typography.Text>
      </Row>
      <Row>
        <Col style={{ marginRight: '0.5em' }}>
          {dayjs(updatedAt).format('DD-MMM-YYYY')}
        </Col>
      </Row>
    </div>
  )
}

const RepliesAction = ({ comments }) => {
  return (
    <div style={{ marginLeft: '1em' }}>
      <Row>
        <Typography.Text>Replies:</Typography.Text>
      </Row>
      <Row>
        <Col style={{ marginRight: '0.5em' }}>{comments.length + 1}</Col>
      </Row>
    </div>
  )
}

export default function Description({ articleData }) {
  const {
    title,
    description,
    image,
    country,
    short_description: shortDescription,
    updatedAt,
    short_query: shortQuery,
    user,
    plugin_comments: comments,
  } = articleData

  useEffect(() => {
    if (
      country.data?.attributes?.name !== 'India' &&
      process.env.NODE_ENV === 'production'
    ) {
      try {
        window.adsbygoogle = window.adsbygoogle || []
        window.adsbygoogle.push({})
      } catch (e) {
        console.error(e)
      }
    }
  }, [])

  return (
    <>
      <Card
        title={<TitleWithAuthor title={title} user={user} />}
        style={{ marginBottom: '1em' }}
        actions={[
          <CreatedAction key="user" user={user} />,
          <UpdatedAction key="update" updatedAt={updatedAt} />,
          <RepliesAction key="ellipsis" comments={comments} />,
        ]}
      >
        <Row>
          <Col>
            {country.data?.attributes?.name !== 'India' &&
              process.env.NODE_ENV === 'production' && (
                <Row>
                  <Col style={{ width: '100%' }}>
                    {/* FTAppArticleHorizontal */}
                    <ins
                      className="adsbygoogle"
                      style={{ display: 'block', textAlign: 'center' }}
                      data-ad-client="ca-pub-9791786401617970"
                      data-ad-slot="3254802733"
                      data-ad-format="auto"
                      data-full-width-responsive="true"
                    />
                  </Col>
                </Row>
              )}
          </Col>
        </Row>
        {shortQuery && (
          <Row style={{ paddingBottom: '16px' }}>
            <Col>
              <Typography.Text>{shortQuery}</Typography.Text>
            </Col>
          </Row>
        )}
      </Card>
      <Row>
        <Col id="acceptedAnswer">
          <Title level={4} style={{ color: '#1890ff' }}>
            <CheckOutlined style={{ marginRight: '16px' }} />
            <span>Short Answer</span>
          </Title>
          <ReactMarkdown>{shortDescription}</ReactMarkdown>
        </Col>
      </Row>
      {country.data?.attributes?.name === 'India' && (
        <Row>
          <Col style={{ minWidth: '250px' }}>
            <a target="_blank" href="https://bit.ly/2YUNebF" rel="noreferrer">
              <Image
                width={728}
                height={90}
                alt=""
                data-src="https://assets.fintrakk.com/Zerodha-Banner-728x90.png"
                src="https://assets.fintrakk.com/Zerodha-Banner-728x90.png"
              />
            </a>
          </Col>
        </Row>
      )}

      <Row>
        <Title level={4} style={{ color: '#1890ff' }}>
          <MenuUnfoldOutlined style={{ marginRight: '16px' }} />
          <span>Detailed Answer</span>
        </Title>
        <Col id="suggestedAnswer">
          <DetailsWithPhoto details={description} image={image} />
        </Col>
      </Row>
      <Row>
        {country.data?.attributes?.name === 'India' && (
          <OptinInline id="om-lsfvr08sg95yvtrnnysi-holder" />
        )}
      </Row>
    </>
  )
}

Description.propTypes = {
  articleData: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    short_description: PropTypes.string.isRequired,
  }).isRequired,
}
